import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IcGraphComponent } from '../../Icons/ic-graph/ic-graph.component';
import { IcImportComponent } from '../../Icons/ic-import/ic-import';
import { IcExportComponent } from '../../Icons/ic-export/ic-export';
import { IcTransitComponent } from '../../Icons/ic-transit/ic-transit';
import { IcEmcsComponent } from '../../Icons/ic-emcs/ic-emcs';
import { IcWarehouseComponent } from '../../Icons/ic-warehouse/ic-warehouse';
import { IcTasksComponent } from '../../Icons/ic-tasks/ic-tasks.component';
import { IcGlobeComponent } from '../../Icons/ic-globe/ic-globe';
import { IcCommodityClassifierComponent } from '../../Icons/ic-commodity-classifier/ic-commodity-classifier';

/**
 * ModuleIconComponent component.
 * Provides UI presentation and event handling for module icon component.
 */
@Component({
  selector: 'app-module-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IcGraphComponent,
    IcImportComponent,
    IcExportComponent,
    IcTransitComponent,
    IcEmcsComponent,
    IcWarehouseComponent,
    IcTasksComponent,
    IcGlobeComponent,
    IcCommodityClassifierComponent,
  ],
  templateUrl: './module-icon.component.html',
})
export class ModuleIconComponent {
  /** Property icon name. */
  iconName = input.required<string>();
  /**
   * Input property for width.
   */
  width = input<number>(14);
  /**
   * Input property for height.
   */
  height = input<number>(14);
  /**
   * Input property for white.
   */
  white = input<boolean>(false);

  /** Property color. */
  color = computed(() => (this.white() ? '#ffffff' : null));
}
